import React from 'react';
import { ItemDto } from '@app/models/dtos/strapi';

function AboutVacancy({ about }: { about: ItemDto }) {
    return (
        <div className="flex w-full justify-center bg-blue-opacity">
            <div className="container grid grid-flow-row grid-cols-1 gap-[50px] py-[60px] md:grid-cols-2 md:gap-[114px]">
                <div>
                    <p className="P2 !text-black-1">About The Role</p>
                    <p className="h4-responsive text-balck-1 mt-6">{about.title}</p>
                </div>
                <p className="P1 mt-12 text-black-2">{about.description}</p>
            </div>
        </div>
    );
}

export default AboutVacancy;
